import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { Fragment } from 'react/jsx-runtime';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';
import { RestrictedActionsMap } from '../msg-group-restricted-actions-off';

export interface MsgGroupRestrictedActionsContentProps {
  message: Msg;
}

export const MsgGroupRestrictedActionsContent = memo(function MsgGroupRestrictedActionsContent({
  message,
}: MsgGroupRestrictedActionsContentProps) {
  const { operator_user_id, restricted_actions } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);

  return (
    <MyTrans
      i18nKey="chat.groupMessageRestrictedActionsText"
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        actions: (
          <Text as="span" color="fg.muted">
            {restricted_actions?.map((action: string, index: number) => (
              <Fragment key={index}>
                {index > 0 && ', '}
                {RestrictedActionsMap[action as keyof typeof RestrictedActionsMap]}
              </Fragment>
            ))}
          </Text>
        ),
      }}
    ></MyTrans>
  );
});
